<section class="content-header" style="padding: 0.5% !important;">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-md-6">
        <ol class="breadcrumb float-sm-left">
          <li class="breadcrumb-item">
            <a [routerLink]="['//admin']"
              ><i class="fas fa-home"></i> &nbsp;Trang chủ</a
            >
          </li>
          <li class="breadcrumb-item active">Sinh hoạt cộng đồng</li>
        </ol>
      </div>
      <div class="col-md-6 offset-md-6">
        <button
          class="btn btn-success btn-sm"
          (click)="ExportExcel()"
          style="float: right; margin-right: 5px;"
        >
          <i class="fas fa-file-excel"></i> Xuất excel tổng hợp
        </button>
        <!-- <button
          class="btn btn-success btn-sm"
          (click)="ExportExcelChiTiet()"
          style="float: right; margin-right: 5px;"
        >
          <i class="fas fa-file-excel"></i> Xuất excel chi tiết
        </button> -->
        <button
          class="btn btn-sm btn-warning"
          (click)="open(InsertGiaHanModal, 'xl', '', '')"
          style="float: right; margin-right: 5px;"
        >
          <i class="fas fa-file-excel"></i> Gia hạn
        </button>
      </div>
    </div>
  </div>
</section>
<section class="content cus-body" *ngIf="isDisplay">
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-md-3">
          <label>Hệ</label>
          <ng-select [(ngModel)]="ID_he">
            <ng-option value="">Chọn hệ</ng-option>
            <ng-option *ngFor="let p of dataHe" [value]="p.ID_he">{{
              p.Ten_he
            }}</ng-option>
          </ng-select>
        </div>
        <div class="col-md-3">
          <label>Khoa</label>
          <ng-select [(ngModel)]="ID_khoa" (change)="getListLop()">
            <ng-option value="">Chọn khoa</ng-option>
            <ng-option *ngFor="let p of dataKhoa" [value]="p.ID_khoa">{{
              p.Ten_khoa
            }}</ng-option>
          </ng-select>
        </div>
        <div class="col-md-3">
          <label>Khóa</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="Khoa_hoc"
            placeholder="Khóa học"
          />
        </div>
        <div class="col-md-3">
          <label>Lớp</label>
          <ng-select [(ngModel)]="ID_lop">
            <ng-option value="">Chọn lớp</ng-option>
            <ng-option *ngFor="let p of dataLop" [value]="p.ID_lop">{{
              p.Ten_lop
            }}</ng-option>
          </ng-select>
        </div>
        <div class="col-md-3">
          <label>Mã sinh viên</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="Ma_sv"
            placeholder="Mã sinh viên"
          />
        </div>
        <div class="col-md-3">
          <label>Họ tên</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="Ho_ten"
            placeholder="Họ tên"
          />
        </div>
        <div class="col-md-3">
          <label>Trạng thái nộp</label>
          <ng-select [(ngModel)]="Status">
            <ng-option *ngFor="let p of daGui" [value]="p.id">{{
              p.ten
            }}</ng-option>
          </ng-select>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="content cus-body">
  <div class="card">
    <div class="card-body">
      <div class="tab-content">
        <div class="active tab-pane">
          <div class="row">
            <div class="col-md-6">
              Hiển thị
              <select (change)="handlePageSizeChange($event)">
                <option *ngFor="let size of pageSizes" [ngValue]="size">
                  {{ size }}
                </option>
              </select>
              kết quả
            </div>
            <div class="col-md-6">
              <button
                title="Ẩn/hiện bộ lọc"
                style="float: right; margin: 0 0 5px 5px;"
                (click)="buttonFilter()"
              >
                <i class="fas fa-filter"></i>
              </button>
              <button
                title="Tải lại"
                style="float: right; margin-bottom: 5px;"
                (click)="refesh()"
              >
                <i class="fas fa-redo-alt"></i>
              </button>
              <button
                class="btn btn-success btn-sm"
                (click)="getList()"
                style="float: right; margin-right: 15px;"
              >
                Tìm kiếm
              </button>
            </div>
          </div>
          <div
            class="table-responsive"
            style="max-height: 60vh; margin-bottom: 15px;"
          >
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      (change)="chonall()"
                      id="checkboxall"
                      [checked]="false"
                    />
                  </th>
                  <th>Mã sinh viên</th>
                  <th>Họ và tên</th>
                  <th>Giới tính</th>
                  <th>Khoa - Lớp</th>
                  <th>Khóa học</th>
                  <th>Ngày gia hạn</th>
                  <th>Tổng điểm</th>
                  <th>Thao tác</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let data of dataTable; let i = index; let odd = odd"
                >
                  <td>
                    <input
                      type="checkbox"
                      (change)="SelectRow(data.ID_sv)"
                      name="checkbox{{ data.ID_sv }}"
                      id="checkbox{{ data.ID_sv }}"
                      [checked]="data.Selected"
                      value="{{ data.ID_sv }}"
                    />
                  </td>
                  <td style="white-space: nowrap;">{{ data.Ma_sv }}</td>
                  <td style="white-space: nowrap;">{{ data.Ho_ten }}</td>
                  <td>{{ data.Gioi_tinh }}</td>
                  <td>{{ data.Ten_khoa }} - {{ data.Ten_lop }}</td>
                  <td>{{ data.Khoa_hoc }}</td>
                  <td>{{ data.Den_ngay | date: 'dd/MM/yyyy' }}</td>
                  <td>{{ data.Tong_diem }}</td>
                  <td>
                    <button
                      class="btn btn-sm btn-warning"
                      (click)="open(DetailModal, 'xl', 'Detail', data)"
                      style="margin-right: 7px;"
                    >
                      <i class="fas fa-eye" title="Chi tiết"></i>
                    </button>
                  </td>
                </tr>
                <tr *ngIf="dataTable.length == 0">
                  <td colspan="15" class="text-center">Không có kết quả</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row">
            <div class="col-md-6">
              <p style="float: left; font-weight: bold;">
                Tổng số {{ totalItem | number }} kết quả, đã lọc được
                {{ totalItemFilter | number }} kết quả
              </p>
            </div>
            <div class="col-md-6">
              <nav aria-label="Page navigation example" style="float: right;">
                <ul class="pagination">
                  <li class="page-item" [class.disabled]="page == 1">
                    <a class="page-link" (click)="changPage(1)">Đầu</a>
                  </li>
                  <li class="page-item" [class.disabled]="page == 1">
                    <a class="page-link" (click)="changPage('pre')">Trước</a>
                  </li>
                  <ng-container *ngIf="page > 4">
                    <li class="page-item"><a class="page-link">...</a></li>
                  </ng-container>
                  <ng-container *ngFor="let element of arrNumberPage_chil">
                    <li class="page-item" [class.active]="page == element">
                      <a class="page-link" (click)="changPage(element)">{{
                        element
                      }}</a>
                    </li>
                  </ng-container>
                  <ng-container *ngIf="page < numberPage - 4">
                    <li class="page-item"><a class="page-link">...</a></li>
                  </ng-container>
                  <li class="page-item" [class.disabled]="page == numberPage">
                    <a class="page-link" (click)="changPage('next')">Sau</a>
                  </li>
                  <li class="page-item" [class.disabled]="page == numberPage">
                    <a class="page-link" (click)="changPage(numberPage)"
                      >Cuối</a
                    >
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<ng-template #DetailModal let-modal>
  <div
    class="modal-header m-header text-center"
    style="padding-top: 0px; padding-bottom: 0px;"
  >
    <h4 class="modal-title h-title w-100">Chi tiết hoạt động</h4>
    <span
      (click)="modal.dismiss('Cross click')"
      aria-hidden="true"
      style="font-size: 25px;"
      >&times;</span
    >
  </div>
  <div class="row">
    <div class="col-md-6 offset-md-6">
      <!-- <button
        class="btn btn-outline-danger btn-sm"
        style="float: right; margin-right: 5px;"
        (click)="Refuse()"
      >
        <i class="fas fa-times text-danger"></i> Từ chối
      </button>
      <button
        class="btn btn-outline-success btn-sm"
        style="float: right; margin-right: 5px;"
        (click)="Accept()"
      >
        <i class="fas fa-check"></i> Duyệt
      </button> -->
      <button
        class="btn btn-outline-primary btn-sm"
        style="float: right; margin-right: 5px;"
        (click)="Save()"
      >
        <i class="fas fa-save"></i> Lưu
      </button>
    </div>
  </div>
  <div class="modal-body" style="margin-top: 5px; padding-top: 5px;">
    <div
      class="table-responsive"
      style="max-height: 60vh; margin-bottom: 15px;"
    >
      <table class="table table-bordered">
        <thead>
          <!-- <th>
         
          </th> -->
          <th class="text-center">Tên hoạt động</th>
          <th class="text-center">Mô tả</th>
          <th class="text-center">Thời gian</th>
          <th class="text-center">Điểm</th>
          <th class="text-center">Điểm hội đồng</th>
          <th class="text-center">Ghi chú</th>
          <th class="text-center">Minh chứng</th>
          <th class="text-center">Trạng thái</th>
          <th class="text-center">Thao tác</th>
        </thead>
        <tbody>
          <tr
            *ngFor="
              let data of dataStudent
                | paginate: { itemsPerPage: 10, currentPage: page };
              let i = index
            "
          >
            <td>{{ data.Ten_hoat_dong }}</td>
            <td>{{ data.Mo_ta }}</td>
            <td>{{ data.Thoi_gian }}</td>
            <td>{{ data.Diem }}</td>
            <td
              class="text-center"
              *ngIf="
                data.Trang_thai == 0 || data.Trang_thai == 3;
                else elseBlock
              "
            >
              <input
                class="form-control"
                type="number"
                min="0"
                max="10"
                [(ngModel)]="data.Diem_hoi_dong"
              />
            </td>
            <ng-template #elseBlock>
              <td class="text-center">
                {{ data.Diem_hoi_dong }}
              </td>
            </ng-template>
            <td>
              <input class="form-control" [(ngModel)]="data.Ghi_chu" />
            </td>
            <!-- <td>{{ data.Mo_ta }}</td> -->
            <td class="text-center">
              <a href="{{ data.URL_minh_chung }}" download target="_blank"
                ><i class="fas fa-download"></i
              ></a>
            </td>
            <td class="text-center" *ngIf="data.Trang_thai == 0">
              <p>Khởi tạo</p>
            </td>
            <td class="text-center" *ngIf="data.Trang_thai == 1">
              <p class="text-success">Đã duyệt</p>
            </td>
            <td class="text-center" *ngIf="data.Trang_thai == 2">
              <p class="text-danger">Từ chối</p>
            </td>
            <td class="text-center" *ngIf="data.Trang_thai == 3">
              <p class="text-danger">Đã sửa</p>
            </td>
            <td class="text-center">
              <button
                class="btn btn-outline-success btn-sm"
                (click)="AcceptDetail(data)"
                download
                target="_blank"
              >
                <i class="fas fa-check"></i>
              </button>
              <button
                class="btn btn-outline-success btn-sm ml-1"
                (click)="RefuseDetail(data)"
                download
                target="_blank"
              >
                <i class="fas fa-times text-danger"></i>
              </button>
              <button
              *ngIf="data.Trang_thai == 1"
              class="btn btn-sm btn-danger"
              (click)="CancelApproval(data)"
              title="Hủy duyệt"
            >
              <i class="fas fa-ban"></i>
            </button>
            </td>
          </tr>
          <tr *ngIf="dataTable.length == 0">
            <td colspan="7" class="text-center">Không có kết quả</td>
          </tr>
        </tbody>
      </table>
      <pagination-controls
        class="float-right"
        (pageChange)="page = $event"
        previousLabel="Trước"
        nextLabel="Sau"
      ></pagination-controls>
    </div>
  </div>
</ng-template>

<ng-template #InsertGiaHanModal let-modal>
  <div
    class="modal-header m-header text-center"
    style="padding-top: 0px; padding-bottom: 0px;"
  >
    <h4 class="modal-title h-title w-100">Gia hạn</h4>
    <span
      (click)="modal.dismiss('Cross click')"
      aria-hidden="true"
      style="font-size: 25px;"
      >&times;</span
    >
  </div>
  <div class="modal-body" style="margin-top: 5px; padding-top: 5px;">
    <form class="form-horizontal" [formGroup]="Action">
      <div class="row" style="font-family: sans-serif;">
        <div class="col-md-3">
          <label class="col-md-10 require">Thời gian</label>
        </div>
        <div class="col-md-9">
          <input
            id="dateGiahan"
            #dateGiahan
            class="form-control"
            required
            type="date"
            formControlName="Thoi_gian"
            min="{{ minDate }}"
            [ngClass]="{
              'is-invalid': submitted && checkvalue.Thoi_gian.errors
            }"
          />
          <div
            *ngIf="submitted && checkvalue.Thoi_gian.errors"
            class="invalid-feedback"
          >
            <div *ngIf="checkvalue.Thoi_gian.errors.required">
              Thời gian không được bỏ trống!
            </div>
            <div *ngIf="checkvalue.Thoi_gian.errors.maxlength">
              Thời gian tối đa 100 ký tự!
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <div class="float-right">
      <button type="button" class="btn btn-md btn-success" (click)="onSubmit()">
        <i class="fa-plus-circle fas"></i> Lưu
      </button>
      <button
        type="button"
        class="btn btn-md btn-danger"
        (click)="modal.dismiss('Cross click')"
        style="margin-left: 1em;"
      >
        <i class="far fa-times-circle"></i> Đóng
      </button>
    </div>
  </div>
</ng-template>
